var _circle, _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyBudgets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#C6E7F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11492_340646)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 34,
    width: 39,
    height: 44,
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 100,
    width: 80,
    height: 32,
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1667 58.7969V24H47.125C43.7307 24 41 26.7377 41 30.1406V148.859C41 152.262 43.7307 155 47.125 155H132.875C136.269 155 139 152.262 139 148.859V64.9375H104.292C100.923 64.9375 98.1667 62.1742 98.1667 58.7969ZM57.3333 42.4219C57.3333 41.291 58.247 40.375 59.375 40.375H79.7917C80.9197 40.375 81.8333 41.291 81.8333 42.4219V46.5156C81.8333 47.6465 80.9197 48.5625 79.7917 48.5625H59.375C58.247 48.5625 57.3333 47.6465 57.3333 46.5156V42.4219ZM57.3333 58.7969C57.3333 57.666 58.247 56.75 59.375 56.75H79.7917C80.9197 56.75 81.8333 57.666 81.8333 58.7969V62.8906C81.8333 64.0215 80.9197 64.9375 79.7917 64.9375H59.375C58.247 64.9375 57.3333 64.0215 57.3333 62.8906V58.7969ZM106.54 122.25H118.583C120.839 122.25 122.667 124.082 122.667 126.344C122.667 128.606 120.839 130.438 118.583 130.438H106.54C102.342 130.438 98.5597 128.099 96.6788 124.333C95.9259 122.818 94.6142 122.664 94.0833 122.664C93.5525 122.664 92.2407 122.815 91.5261 124.248L89.5687 128.173C89.2297 128.853 88.7085 129.425 88.0634 129.825C87.4183 130.224 86.6749 130.435 85.9167 130.435C85.8197 130.435 85.7253 130.43 85.6257 130.422C83.9796 130.307 82.5632 129.207 82.0452 127.636L77.75 114.725L75.0422 122.882C73.5391 127.4 69.3307 130.438 64.5787 130.438H61.4167C59.1606 130.438 57.3333 128.606 57.3333 126.344C57.3333 124.082 59.1606 122.25 61.4167 122.25H64.5787C65.8114 122.25 66.9036 121.462 67.2941 120.29L71.9364 106.31C72.7785 103.8 75.1111 102.111 77.75 102.111C80.3889 102.111 82.7215 103.797 83.5611 106.31L87.1034 116.964C92.1489 112.822 100.897 114.482 103.947 120.587C104.463 121.626 105.468 122.25 106.54 122.25ZM137.214 50.8652L112.229 25.791C111.08 24.6396 109.523 24 107.89 24H106.333V56.75H139V55.1893C139 53.5773 138.362 52.0166 137.214 50.8652Z",
    fill: "#5CFFE9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3253 114.121L61.2238 81.6133L67.7382 88.2059L34.8397 120.714L28.3253 114.121Z",
    fill: "#00465D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7581 122.857L41.3533 97.5655C41.4958 97.4247 41.7255 97.4261 41.8663 97.5686L51.5539 107.373C51.6947 107.515 51.6933 107.745 51.5508 107.885L25.9556 133.177C25.8131 133.318 25.5835 133.316 25.4426 133.174L15.7551 123.37C15.6143 123.227 15.6156 122.998 15.7581 122.857Z",
    fill: "#1688AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3813 16C67.7483 16.0002 49.4009 34.3484 49.4009 56.9814C49.4011 79.6143 67.7485 97.9617 90.3813 97.9619C113.014 97.9619 131.363 79.6145 131.363 56.9814C131.363 34.3482 113.015 16 90.3813 16ZM90.3823 22.6865C109.322 22.6867 124.676 38.0414 124.676 56.9814C124.676 75.9214 109.322 91.2753 90.3823 91.2754C71.4423 91.2754 56.0876 75.9214 56.0874 56.9814C56.0874 38.0413 71.4422 22.6865 90.3823 22.6865Z",
    fill: "#1688AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.3821 91.2759C71.4419 91.2759 56.0879 75.9219 56.0879 56.9817C56.0879 38.0415 71.4419 22.6875 90.3821 22.6875C109.322 22.6875 124.676 38.0415 124.676 56.9817C124.676 75.9219 109.322 91.2759 90.3821 91.2759Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11492_340646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 131,
    fill: "white",
    transform: "translate(41 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBudgets);
export default __webpack_public_path__ + "static/media/empty-budgets.e2de0b8d58e561f83fa05f461c43b3e9.svg";
export { ForwardRef as ReactComponent };